import React from 'react';

export interface InputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'size'> {
  /** Input type (restricted to common types) */
  type?: 'text' | 'email' | 'password' | 'url' | 'tel' | 'number' | 'search' | 'date' | 'hidden';
  /** Validation state */
  state?: 'default' | 'error' | 'success';
  /** Input size */
  size?: 'sm' | 'md' | 'lg';
  /** Full width */
  fullWidth?: boolean;
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  (
    {
      type = 'text',
      state = 'default',
      size = 'md',
      fullWidth = false,
      disabled,
      readOnly,
      required,
      className = '',
      'aria-invalid': ariaInvalid,
      'aria-required': ariaRequired,
      ...rest
    },
    ref
  ) => {
    const classes = [
      'hi-ui-input',
      `hi-ui-input-size-${size}`,
      state !== 'default' && `hi-ui-input-state-${state}`,
      fullWidth && 'hi-ui-input-full-width',
      disabled && 'hi-ui-input-disabled',
      readOnly && 'hi-ui-input-readonly',
      className,
    ]
      .filter(Boolean)
      .join(' ');

    return (
      <input
        ref={ref}
        type={type}
        disabled={disabled}
        readOnly={readOnly}
        required={required}
        className={classes}
        aria-invalid={ariaInvalid ?? (state === 'error' ? true : undefined)}
        aria-required={ariaRequired ?? (required ? true : undefined)}
        {...rest}
      />
    );
  }
);

Input.displayName = 'Input';
